module.exports = __webpack_public_path__ + "static/media/new_logo.0e967a9e.png";